import React from 'react';
import { google, slack, atlassian, dropbox, shopify } from './imports';
import './brand.css';

const Brand = () => (
	<div className="gpt3__brand section__padding">
		<div>
			<img src={google} alt="pix-1" />
		</div>
		<div>
			<img src={slack} alt="pix-3" />
		</div>
		<div>
			<img src={atlassian} alt="pix-4" />
		</div>
		<div>
			<img src={dropbox} alt="pix-5" />
		</div>
		<div>
			<img src={shopify} alt="pix-6" />
		</div>
	</div>
);

export default Brand;
